import { Component } from '@angular/core';
import { UploadableDirective } from 'src/directives/uploadable.directive';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

_('generic.unknown');

@Component({
    selector: 'app-upload-progress-bar',
    templateUrl: './upload-progress-bar.component.html',
    styleUrls: ['./upload-progress-bar.component.scss'],
    standalone: false
})
export class UploadProgressBarComponent extends UploadableDirective {
  getPercentage(file: any): number {
    return file?.progress?.data?.percentage || 0;
  }

  getSpeed(file: any): number {
    return file?.progress?.data?.speed || 0;
  }

  getEta(file: any): any {
    return file?.progress?.data?.eta;
  }

  hasEta(file: any): boolean {
    return !!(file?.progress?.data?.eta);
  }
}
